import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Select, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

import { AuthState, AuthStateModel } from '../store/state/auth.state';
import { RefreshTokens } from './../store/actions/auth.action';

@Injectable()
export class AuthGuard implements CanActivate {
    @Select(AuthState.isAuthenticated) public auth$: Observable<boolean>;
    constructor(private store: Store, private localize: LocalizeRouterService, private router: Router) {}

    public canActivate(): boolean | Observable<boolean> {
        const isAuthenticated: boolean = this.store.selectSnapshot(AuthState.isAuthenticated);
        if (isAuthenticated) {
            return of(true);
        }
        return this.store.dispatch(new RefreshTokens()).pipe(
            withLatestFrom(this.auth$),
            map(([, auth]: [AuthStateModel, boolean]) => {
                if (auth) {
                    return true;
                } else {
                    this.router.navigate([this.localize.translateRoute('/auth/login')]);
                    return false;
                }
            })
        );
    }
}
